export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  status: '连载中' | '已完结';
  latestChapter: string;
  updateDay: string;
  updateTime: string;
  chapters: number;
  progress: string;
  rating: string;
  description: string;
  tags: string[];
  cover: string;
  featured?: boolean;
}

export const CATEGORIES = ['全部', '热血冒险', '科幻奇幻', '恋爱日常', '悬疑惊悚', '搞笑治愈'];

export const comics: Comic[] = [
  {
    id: 'jianyu-xingchen',
    title: '剑与星辰',
    author: '南山拾贰',
    category: '热血冒险',
    status: '连载中',
    latestChapter: '第 128 话 · 星坠之约',
    updateDay: '周五',
    updateTime: '18:30',
    chapters: 128,
    progress: '已读到 103 话',
    rating: '9.6',
    description:
      '背负旧日誓言的白发少年，手持一柄断剑踏上寻星之路。热血的修行、并肩的伙伴、命运的抉择，一部让人停不下来的少年冒险长篇。',
    tags: ['少年热血', '冒险', '羁绊'],
    cover: 'https://readdy.ai/api/search-image?query=a%20stylized%20youth%20fantasy%20comic%20cover%20illustration%20of%20a%20white-haired%20sword%20boy%20under%20a%20glowing%20starry%20sky%2C%20warm%20orange%20and%20golden%20light%2C%20dynamic%20action%20pose%2C%20clean%20minimalist%20background%2C%20manga%20style%2C%20high%20contrast%2C%20vibrant%20colors&width=600&height=850&seq=comic-jyxc&orientation=portrait',
    featured: true,
  },
  {
    id: 'xinghai-shiguang',
    title: '星海拾光',
    author: '云眠工作室',
    category: '科幻奇幻',
    status: '连载中',
    latestChapter: '第 76 话 · 引力尽头',
    updateDay: '周三',
    updateTime: '20:00',
    chapters: 76,
    progress: '养肥中 · 已读 41 话',
    rating: '9.2',
    description:
      '在浩瀚星海间穿行的信使，替散落宇宙的人们递送一封封迟到的思念。温柔的科幻叙事，光与尘埃之间藏着最动人的情感。',
    tags: ['科幻', '治愈', '太空'],
    cover: 'https://readdy.ai/api/search-image?query=a%20soft%20sci-fi%20comic%20cover%20of%20a%20young%20courier%20floating%20in%20a%20dreamy%20nebula%20with%20drifting%20letters%20of%20light%2C%20teal%20and%20cream%20palette%2C%20gentle%20glow%2C%20minimalist%20clean%20background%2C%20manga%20style%2C%20cinematic%20lighting&width=600&height=850&seq=comic-xhsg&orientation=portrait',
    featured: true,
  },
  {
    id: 'tiandianshi-gaobai',
    title: '甜点师的告白',
    author: '苏小糖',
    category: '恋爱日常',
    status: '连载中',
    latestChapter: '第 52 话 · 樱桃季',
    updateDay: '周六',
    updateTime: '12:00',
    chapters: 52,
    progress: '已读完 52 话',
    rating: '9.4',
    description:
      '固执的甜点师与怕甜的冷漠主编，在一家小巷烘焙店里展开的拉锯战。酸甜交织的日常，甜到心里的恋爱轻喜剧。',
    tags: ['恋爱', '美食', '轻喜'],
    cover: 'https://readdy.ai/api/search-image?query=a%20sweet%20romance%20comic%20cover%20of%20a%20cheerful%20pastry%20chef%20holding%20a%20strawberry%20cake%20in%20a%20warm%20bakery%2C%20soft%20pink%20and%20cream%20tones%2C%20cozy%20atmosphere%2C%20minimalist%20clean%20background%2C%20manga%20style%2C%20gentle%20lighting&width=600&height=850&seq=comic-tdsg&orientation=portrait',
  },
  {
    id: 'shenye-zhentanshe',
    title: '深夜侦探社',
    author: '墨白青',
    category: '悬疑惊悚',
    status: '连载中',
    latestChapter: '第 89 话 · 雾中来信',
    updateDay: '周二',
    updateTime: '21:30',
    chapters: 89,
    progress: '已读到 67 话',
    rating: '9.1',
    description:
      '只在午夜营业的侦探事务所，接手一件件无法用常理解释的怪案。烧脑的推理与紧绷的氛围，层层反转令人欲罢不能。',
    tags: ['推理', '悬疑', '都市怪谈'],
    cover: 'https://readdy.ai/api/search-image?query=a%20moody%20mystery%20comic%20cover%20of%20a%20detective%20silhouette%20under%20a%20dim%20street%20lamp%20in%20fog%2C%20deep%20amber%20and%20charcoal%20tones%2C%20noir%20atmosphere%2C%20minimalist%20dark%20background%2C%20manga%20style%2C%20dramatic%20shadow%20lighting&width=600&height=850&seq=comic-syzt&orientation=portrait',
  },
  {
    id: 'mengchong-richangbu',
    title: '萌宠日常部',
    author: '毛球君',
    category: '搞笑治愈',
    status: '已完结',
    latestChapter: '全 120 话 · 完结纪念',
    updateDay: '周一',
    updateTime: '08:00',
    chapters: 120,
    progress: '已读完 120 话',
    rating: '9.3',
    description:
      '社团活动就是养猫撸狗喂仓鼠？一群毛孩子和它们的铲屎官，在轻松日常里笑出眼泪又暖到心底的治愈群像剧。',
    tags: ['萌宠', '日常', '治愈'],
    cover: 'https://readdy.ai/api/search-image?query=a%20cute%20slice-of-life%20comic%20cover%20of%20a%20pile%20of%20fluffy%20cats%20and%20dogs%20around%20a%20smiling%20teenager%2C%20warm%20cream%20and%20peach%20palette%2C%20soft%20and%20playful%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-mcrc&orientation=portrait',
  },
  {
    id: 'shikong-xinshi',
    title: '时空信使',
    author: '时之沙',
    category: '科幻奇幻',
    status: '连载中',
    latestChapter: '第 64 话 · 昨日之影',
    updateDay: '周四',
    updateTime: '19:00',
    chapters: 64,
    progress: '已读到 58 话',
    rating: '9.0',
    description:
      '误入时空裂缝的快递员，必须在七天里找到回家的路。每一集都是一次穿越，每一次抉择都在改写记忆中的未来。',
    tags: ['时空', '冒险', '悬疑'],
    cover: 'https://readdy.ai/api/search-image?query=a%20time-travel%20comic%20cover%20of%20a%20young%20courier%20stepping%20into%20a%20glowing%20clockwork%20portal%2C%20golden%20and%20deep%20green%20tones%2C%20surreal%20and%20cinematic%2C%20minimalist%20dark%20background%2C%20manga%20style&width=600&height=850&seq=comic-skxs&orientation=portrait',
  },
  {
    id: 'mowang-daren',
    title: '魔王大人营业中',
    author: '章鱼烧',
    category: '搞笑治愈',
    status: '连载中',
    latestChapter: '第 41 话 · 勇者来面试',
    updateDay: '周日',
    updateTime: '10:30',
    chapters: 41,
    progress: '已读完 41 话',
    rating: '9.5',
    description:
      '灭世魔王退休后，在人间开了一家深夜拉面馆。昔日的勇者变成常客，神魔的恩怨在烟火气里慢慢消融，笑点与温情齐飞。',
    tags: ['无厘头', '温馨', '反套路'],
    cover: 'https://readdy.ai/api/search-image?query=a%20comedy%20comic%20cover%20of%20a%20horned%20demon%20lord%20cheerfully%20cooking%20ramen%20in%20a%20cozy%20night%20stall%2C%20warm%20orange%20and%20cream%20tones%2C%20playful%20and%20whimsical%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-mwdr&orientation=portrait',
    featured: true,
  },
  {
    id: 'yuxiang-kafeiguan',
    title: '雨巷咖啡馆',
    author: '青禾',
    category: '恋爱日常',
    status: '连载中',
    latestChapter: '第 33 话 · 一把旧伞',
    updateDay: '周三',
    updateTime: '15:00',
    chapters: 33,
    progress: '养肥中 · 已读 18 话',
    rating: '9.0',
    description:
      '开在雨巷尽头的咖啡馆，收留每一个躲雨的人。老板与常客之间那些欲言又止的心动，清淡却绵长的都市恋爱物语。',
    tags: ['都市', '恋爱', '氛围感'],
    cover: 'https://readdy.ai/api/search-image?query=a%20cozy%20romance%20comic%20cover%20of%20a%20caf%C3%A9%20counter%20by%20a%20rainy%20window%20with%20a%20steaming%20cup%2C%20soft%20teal%20and%20cream%20tones%2C%20rain%20droplets%2C%20warm%20and%20intimate%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-yxkfg&orientation=portrait',
  },
  {
    id: 'miwu-jinqu',
    title: '迷雾禁区',
    author: '代号K',
    category: '悬疑惊悚',
    status: '连载中',
    latestChapter: '第 58 话 · 门之后',
    updateDay: '周五',
    updateTime: '23:00',
    chapters: 58,
    progress: '已读到 47 话',
    rating: '8.8',
    description:
      '被浓雾吞没的小镇里，居民们每隔七天就会集体失忆。前来调查的记者，却发现失踪名单上写着自己的名字。',
    tags: ['惊悚', '心理', '迷雾'],
    cover: 'https://readdy.ai/api/search-image?query=a%20dark%20thriller%20comic%20cover%20of%20a%20figure%20walking%20into%20thick%20fog%20toward%20a%20half-hidden%20town%20gate%2C%20muted%20gray-green%20and%20amber%20tones%2C%20eerie%20atmosphere%2C%20minimalist%20dark%20background%2C%20manga%20style%2C%20grainy%20texture&width=600&height=850&seq=comic-mwjq&orientation=portrait',
  },
  {
    id: 'shaonian-yujianlu',
    title: '少年御剑录',
    author: '大圣不空',
    category: '热血冒险',
    status: '已完结',
    latestChapter: '全 96 话 · 归鞘',
    updateDay: '周二',
    updateTime: '17:00',
    chapters: 96,
    progress: '已读完 96 话',
    rating: '9.4',
    description:
      '御剑而行的少年郎，带着一口旧剑行走江湖，斩妖除魔，也探寻身世之谜。爽快的打斗与深厚的友情，一气呵成的冒险。',
    tags: ['仙侠', '热血', '江湖'],
    cover: 'https://readdy.ai/api/search-image?query=a%20wuxia%20fantasy%20comic%20cover%20of%20a%20youth%20sword%20master%20gliding%20over%20misty%20mountains%20on%20a%20floating%20sword%2C%20emerald%20green%20and%20gold%20tones%2C%20dynamic%20and%20epic%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-snyjl&orientation=portrait',
  },
  {
    id: 'yunduan-bianlidian',
    title: '云端便利店',
    author: '半糖主义',
    category: '恋爱日常',
    status: '连载中',
    latestChapter: '第 29 话 · 夜班',
    updateDay: '周六',
    updateTime: '22:00',
    chapters: 29,
    progress: '已读到 24 话',
    rating: '9.1',
    description:
      '开在高楼大厦之间的无人便利店，每到午夜就会迎来各色夜归人。值班店员与神秘客人之间，一段温暖又微妙的遇见。',
    tags: ['都市', '治愈', '恋爱'],
    cover: 'https://readdy.ai/api/search-image?query=a%20nighttime%20romance%20comic%20cover%20of%20a%20bright%20convenience%20store%20glowing%20between%20tall%20city%20buildings%20at%20midnight%2C%20warm%20orange%20and%20cool%20teal%20contrast%2C%20cozy%20and%20cinematic%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-ycbd&orientation=portrait',
  },
  {
    id: 'shanhai-yizhi',
    title: '山海异闻志',
    author: '昆仑绘',
    category: '热血冒险',
    status: '连载中',
    latestChapter: '第 110 话 · 昆仑之巅',
    updateDay: '周一',
    updateTime: '09:00',
    chapters: 110,
    progress: '已读到 92 话',
    rating: '9.2',
    description:
      '少年执笔入《山海》，唤醒沉睡的上古异兽。一部融合东方神话与现代冒险的宏大长卷，画面精美，脑洞大开。',
    tags: ['神话', '国风', '冒险'],
    cover: 'https://readdy.ai/api/search-image?query=a%20mythological%20chinese%20fantasy%20comic%20cover%20of%20a%20young%20scribe%20summoning%20a%20glowing%20ancient%20beast%20from%20an%20old%20scroll%2C%20jade%20green%20and%20vermilion%20red%20tones%2C%20ornate%20and%20epic%2C%20minimalist%20clean%20background%2C%20manga%20style&width=600&height=850&seq=comic-shyz&orientation=portrait',
  },
];